import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  TextField
} from "@material-ui/core";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import FormSpacer from "@saleor/components/FormSpacer";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import { GetAvailableTemplates_templates_edges_node } from "@saleor/dropOff/types/GetAvailableTemplates";
import useNotifier from "@saleor/hooks/useNotifier";
import {
  TemplateCreateInput,
  TemplateStatus,
  TemplateStatusEnum,
  TemplateUpdateInput
} from "@saleor/types/globalTypes";
import * as React from "react";
import { useIntl } from "react-intl";

interface DropOffNameTemplateProps {
  mallId: string;
  isOmiOPS?: boolean;
  isUpdate: boolean;
  newActiveTemplate: boolean;
  templateNameProps: string;
  activeTemplates: GetAvailableTemplates_templates_edges_node[];
  availableTemplates: GetAvailableTemplates_templates_edges_node[];
  onCreateTemplate: (data: TemplateCreateInput) => void;
  onUpdateTemplate: (data: TemplateUpdateInput) => void;
  onSelectChange: (event: string) => void;
  onSetAsActiveTemplate: (data: boolean) => void;
}

const DropOffNameTemplate: React.FC<DropOffNameTemplateProps> = props => {
  const {
    mallId,
    isOmiOPS,
    isUpdate,
    newActiveTemplate,
    templateNameProps,
    activeTemplates,
    availableTemplates,
    onCreateTemplate,
    onUpdateTemplate,
    onSelectChange,
    onSetAsActiveTemplate
  } = props;
  const classes = useTemplateStyles(props);
  const intl = useIntl();
  const notify = useNotifier();

  const [selectedMallId, setSelectedMallId] = React.useState(mallId);
  const [templateName, setTemplateName] = React.useState(templateNameProps);
  const [isNextClicked, setIsNextClicked] = React.useState(false);
  const [checkboxActiveTemplate, setCheckboxActiveTemplate] = React.useState(
    newActiveTemplate
  );

  const onCreateTemplateClick = (templateName, selectedMallId) => {
    const nonDraftTemplates = availableTemplates.filter(
      template => template.status !== TemplateStatus.DRAFT
    );

    if (nonDraftTemplates.length >= 10) {
      setIsNextClicked(false);
      notify({
        status: "error",
        text: "The maximum number of templates has been reached "
      });
    } else {
      onCreateTemplate({
        mall: selectedMallId,
        name: templateName
      });
    }
  };

  React.useEffect(() => {
    setSelectedMallId(mallId);
    onSelectChange(mallId);
  }, [mallId]);

  React.useEffect(() => {
    setCheckboxActiveTemplate(newActiveTemplate);
  }, [newActiveTemplate]);

  return (
    <Container>
      <div className={classes.GeneralInformationRoot}>
        <h3 className={classes.displayFlex}>
          <DashboardOutlinedIcon color="primary" />
          <span className={classes.textMarginLeft}>Name your template</span>
        </h3>
        <div className={classes.textFieldGrid}>
          <div>
            <TextField
              fullWidth
              required
              value={templateName}
              label={intl.formatMessage({
                defaultMessage: "Template Name"
              })}
              onChange={event => {
                if (event.target.value.length > 30) {
                  return;
                }
                setTemplateName(event.target.value);
              }}
            />
          </div>
        </div>

        {activeTemplates && activeTemplates.length > 0 && (
          <div className={classes.textFieldGrid}>
            <form noValidate autoComplete="off">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={checkboxActiveTemplate}
                    onChange={e => {
                      setCheckboxActiveTemplate(e.target.checked);
                      onSetAsActiveTemplate(e.target.checked);
                    }}
                  />
                }
                label="Set as the active template"
              />
            </form>
          </div>
        )}
        <FormSpacer />

        {isOmiOPS ? (
          <div
            className={`${classes.displayFlex} ${classes.displayFlexPaddingTop50}`}
          >
            <Button
              variant="contained"
              className={`${classes.buttonColor} ${classes.displayFlexMarginLeft}`}
              disabled={
                isNextClicked ||
                !templateName ||
                (templateName && templateName.trim().length === 0)
              }
              onClick={() => {
                setIsNextClicked(true);
                if (isUpdate) {
                  onUpdateTemplate({
                    mall: mallId !== "" ? mallId : selectedMallId,
                    name: templateName,
                    status: TemplateStatusEnum.DRAFT
                  });
                } else {
                  onCreateTemplateClick(
                    templateName,
                    mallId !== "" ? mallId : selectedMallId
                  );
                }
                setIsNextClicked(false);
              }}
            >
              <div className={classes.textWhite}>NEXT</div>
            </Button>
          </div>
        ) : (
          <div
            className={`${classes.displayFlex} ${classes.displayFlexPaddingTop50}`}
          >
            <Button
              variant="contained"
              className={`${classes.buttonColor} ${classes.displayFlexMarginLeft}`}
              disabled={
                isNextClicked ||
                !selectedMallId ||
                !templateName ||
                (templateName && templateName.trim().length === 0)
              }
              onClick={() => {
                setIsNextClicked(true);
                if (isUpdate) {
                  onUpdateTemplate({
                    mall: selectedMallId,
                    name: templateName,
                    status: TemplateStatusEnum.DRAFT
                  });
                } else {
                  onCreateTemplateClick(templateName, selectedMallId);
                }
                setIsNextClicked(false);
              }}
            >
              <div className={classes.textWhite}>NEXT</div>
            </Button>
          </div>
        )}
      </div>
    </Container>
  );
};

export default DropOffNameTemplate;
